import React from 'react'

import './404.scss'

const FourOhFour = ({ location }) => {
  const isWebpack = process.env.WEBPACK_DEV_SERVER === true
  if (isWebpack) {
    return (
      <div>
        404
      </div>
    )
  } else {
    window.location = location.pathname + location.search
  }
}

export default FourOhFour



// WEBPACK FOOTER //
// ./src/screens/App/screens/404/404.js